import { Option } from '@eiq/ui';

import { QuestionType } from '@empathy/survey/base';

export const SelectableVariableValueType: Option<QuestionType>[] = [
  {
    text: 'Text',
    value: QuestionType.Input
  },
  {
    text: 'List',
    value: QuestionType.SingleChoice
  }
];
